<template lang="pug">
  span
    span(@click="modal_open")
      slot(name="activator")
    v-dialog.d-inline(v-model="isModalVisible" persistent max-width="480")
      v-card
        title-bar(dark) {{ dialogTitle }}
        v-card-text
          v-select(
            v-model="selectedField"
            :items="items"
            :item-text="fieldText"
            :item-value="fieldValue"
            :label="label"
            persistent-hint
            return-object
            single-line
          )
            template(slot="item" slot-scope="data")
              v-list-tile(v-if="data.item.id === 0")
                v-list-tile-content
                  v-list-tile-title(v-text="data.item.name")
                  v-list-tile-sub-title(v-text="data.item.description")
              v-list-tile(v-else)
                v-list-tile-content
                  v-list-tile-title(v-text="data.item.name")
                  v-list-tile-sub-title(v-text="data.item.description || ''")
        v-card-actions
          v-spacer
          v-btn(flat @click="modal_close") Cancel
          v-btn.primary(@click="save" :disabled='!inputChosen') Save
</template>

<script>
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';

export default {
  components: {
    TitleBar,
  },
  mixins: [Modal],
  data() {
    return {
      selectedField: null,
    };
  },
  computed: {
    dialogTitle() {
      if (this.selectedIds.length === 1) {
        return `${this.title} for Contact`;
      }
      return `${this.title} for ${this.totalContactsSelected} Contacts`;
    },
    inputChosen() {
      return this.selectedField;
    },
    label() {
      return `Select a ${this.fieldName}`;
    },
  },

  props: {
    icon: {
      type: String,
    },
    selectedIds: {
      type: Array,
    },
    items: {
      type: Array,
    },
    title: {
      type: String,
      default: 'add',
    },
    contactUpdateActionPayload: {
      type: Function,
    },
    patchContacts: {
      type: Function,
    },
    fieldName: {
      type: String,
    },
    fieldText: {
      type: String,
    },
    fieldValue: {
      type: String,
    },
    totalContactsSelected: {
      type: Number,
    },
  },

  methods: {
    async save() {
      let actionPayloadValue;
      let actionPayloadField;
      switch (this.fieldName) {
        case 'status':
          actionPayloadValue = this.selectedField.name
          actionPayloadField = this.fieldName
          if (this.selectedField.id === 0) {
            actionPayloadValue = null
          }
          break;
        case 'source':
          actionPayloadValue = this.selectedField.id
          actionPayloadField = 'source_id';
          break;
        default :
          actionPayloadValue = this.selectedField
          actionPayloadField = this.fieldName
          break;
      }
      const action = this.contactUpdateActionPayload({
        [actionPayloadField]: actionPayloadValue
      });
      const payload = {
        action,
        selected: this.selectedIds
      };
      this.modal_close();
      await this.patchContacts(payload);
      this.$emit('deselect-all');
      this.$emit('contact-updated');
      this.selectedField = null;
    },
  },
};
</script>
